// Diccionario de textos de la interfaz por idioma.
// Uso: const c = useCopy("nav") -> objeto con las cadenas del área.
// En "en" solo hay que definir lo traducido: lo que falte hereda el español.
// Textos funcionales cortos ya tienen borrador en inglés (la titular puede
// sustituirlos); el contenido largo queda en español pendiente de traducción.
import { useLang } from "./lang";
import { copy } from "./copyData";

export const useCopy = (area) => {
  const lang = useLang();
  if (lang !== "en") return copy.es[area];
  return { ...copy.es[area], ...(copy.en[area] || {}) };
};
